import { Autocomplete, Box, Button, CircularProgress, FormControl, FormControlLabel, InputAdornment, InputLabel, LinearProgress, linearProgressClasses, MenuItem, Paper, Select, styled, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { MultiInputDateRangeField } from '@mui/x-date-pickers-pro/MultiInputDateRangeField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import React, { useEffect, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs';
import { ArrowDropDownIcon, CalendarIcon, DatePicker } from '@mui/x-date-pickers';
import { ApiDownloadExcel, ApiGetAreaManager, ApiGroupMonthReport, ApiRegionVenues } from '../../apiService/Core/Apicall';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowDropDown, TrendingDownOutlined, TrendingUp, TrendingUpOutlined } from '@mui/icons-material';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Images } from '../../global/GloblImages';
import Left from '../../assets/common/images/Left.png'
import Right from '../../assets/common/images/Right.png'
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import { RootState } from '../../global/config/store';
import { setMonth } from 'date-fns';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import storage from '../../utils/storage';

function CustomeMonthlyReport() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).subtract(2, 'month'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));
    const [groupumonthreport, setgroupmonthreport] = useState<any>([])
    const { DownArrow, UpArrow } = Images()
    const [currentlength, setcurrentlength] = useState(0)
    const [currentmonth, setcurrentmonth] = useState(0)
    const [changelength, setchangelength] = useState(0)
    const [changemonth, setchangemonth] = useState(0)
    const [previouslength, setpreviouslength] = useState(0)
    const Regions = useSelector(RegionList)
    const [previousmonth, setpreviousmonth] = useState(0)
    console.log("console Regions", Regions)
    const [selectedRegion, setselectedRegion] = useState<any>(Regions[0]?.regionId ?? '')
    const [TotalMonth, setTotalMonth] = useState<number>()
    const dispatch = useDispatch()
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const [area, setSelectedArea] = useState<number | string | null>(null)
    const [Areamanagerlist, setareamanagerlist] = useState<any[]>([])




    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0) {
            setselectedRegion(Regions[0].regionId);
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const GetCustomeReport = async () => {
            try {
                const data = {
                    s_month: startMonth.month() + 1,
                    s_year: startMonth.year(),
                    e_month: endMonth.month() + 1,
                    e_year: endMonth.year(),
                    clientEntityId: isGroupScore ? clientEntityIds : storage.getItem('clientEntityId'),
                    ...(selectedRegion && { regionId: selectedRegion }),
                    ...(area && { areaId: area })
                }
                const response = await ApiGroupMonthReport(data);
                setgroupmonthreport(response.data)
                response.data.map((item: any) => {

                })
            }
            catch (error: any) {
                // toast.error(error)
            }
        }
        if (startMonth && endMonth) {
            const timeout = setTimeout(() => {
                GetCustomeReport();
            }, 300);

            return () => clearTimeout(timeout);
        }
    }, [startMonth, endMonth, selectedRegion,area, clientEntity, isGroupScore])

    useEffect(() => {
        setchangemonth(0)
        setchangelength(0)
        setpreviousmonth(0)
        setpreviouslength(0)
        setcurrentmonth(0)
        setcurrentlength(0)

        groupumonthreport.length > 0 && groupumonthreport.map((item: any) => {
            if (item.currentAverage !== null && item.currentAverage !== 0) {
                setcurrentmonth(prev => prev + item.currentAverage)
                setcurrentlength(prev => prev + 1)
            }
            if (item.previousAverage !== null && item.previousAverage !== 0) {
                setpreviousmonth(prev => prev + item.previousAverage)
                setpreviouslength(prev => prev + 1)
            }
            if (item.change !== null && item.change !== 0) {
                setchangemonth(prev => prev + item.change)
                setchangelength(prev => prev + 1)

            }

        })
    }, [groupumonthreport, clientEntity])
    console.log("Current month--->", changemonth)
    console.log("Change Length--->", changelength)

    useEffect(() => {
        setTotalMonth((endMonth.year() - startMonth.year()) * 12 + (endMonth.month() - startMonth.month()) + 1)
    }, [startMonth, endMonth, clientEntity])

    useEffect(() => {
        setEndMonth(dayjs(selectedMonth).startOf('month'))
    }, [selectedMonth])

    const handledownloadExcel = async () => {
        try {
            const query = `?reportType=customMonthReportByVenue&clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem(
                "clientEntityId"
            )}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1}&e_year=${endMonth.year()}${selectedRegion ? `&regionId=${selectedRegion}` : ""}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`;

            const response = await ApiDownloadExcel(query);

            // Create Excel blob
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Add a default filename
            link.setAttribute(
                "download",
                `Custom_Month.xlsx`
            );

            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };

    const handleVenueDashboard = (venueId: string, venueName: string) => {
        if(!venueId){
            return
        }
        const url = `/maindashboard/sitedashboard?v=${encodeURIComponent(venueId)}&n=${encodeURIComponent(venueName)}&s=${encodeURIComponent(selectedMonth)}`;
        window.open(url, '_blank'); // opens in new tab
    };

    const fetchAreaManagers = async () => {
        try {
            const data = `?offset=0&limit=1000&clientEntityId=${isGroupScore ? clientEntityIds : clientEntity}`
            const response = await ApiGetAreaManager(data)
            setareamanagerlist(response.data)
        } catch (error) {
            console.error('Error fetching area managers:', error)
        }
    }

    useEffect(() => {
        clientEntity && fetchAreaManagers()
    }, [clientEntity, isGroupScore])

    return (
        <Box className='w-100 mt-3'>


            <Box className='d-flex flex-wrap-reverse align-items-center justify-content-between mb-2'>
                <Box className='d-flex align-items-center gap-5 justify-content-between'>
                    <Typography className='fw-bold' whiteSpace='nowrap' fontSize={{ xs: '18px', md: '20px' }}> Overall Comparision</Typography>
                    {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                        <Box>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isGroupScore}
                                        onChange={(e) => {setSelectedArea(null); setisGroupScore(e.target.checked)}}
                                    />
                                }
                                label={"Whole Group"}
                            />
                        </Box>)}
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '90px', display: { xs: "flex", md: 'none' } }} className='justify-content-end text-end'>
                            <Autocomplete
                                options={Regions || []}
                                getOptionLabel={(option) => option.regionName || ''}
                                value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                onChange={(event, newValue) => {
                                    setselectedRegion(newValue?.regionId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Region"
                                        variant="outlined"
                                        sx={{ input: { color: 'black' } }} // Ensures text is visible
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                            />
                        </FormControl>
                    )}
                </Box>
                <Box gap={{ xs: 5, md: 1 }} className='d-flex align-items-center justify-content-end col-12 col-md-6'>
                    <Button className='btn-main px-3' onClick={() => { handledownloadExcel() }}>Download Excel</Button>
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '200px', display: { xs: "none", md: 'flex' } }} className='justify-content-end text-end'>
                            {/* <InputLabel id="demo-simple-select-label" shrink={false} sx={{ fontSize: { xs: "14px", md: "18px" } }}>Region: &nbsp;</InputLabel> */}
                            <Autocomplete
                                options={Regions || []}
                                getOptionLabel={(option) => option.regionName || ''}
                                value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                onChange={(event, newValue) => {
                                    setselectedRegion(newValue?.regionId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Region"
                                        variant="outlined"
                                        sx={{ input: { color: 'black' } }} // Ensures text is visible
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                            />
                        </FormControl>
                    )}
                    {/* <Box justifyContent={{ xs: 'start', md: 'end' }} border='1px solid red' className='col-5  d-flex align-itmes-center'> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" minWidth={{ xs: "280px", md: '100px' }} width='fit-contentet' gap={{ xs: 1, md: 1 }}>
                            {storage.getItem('userRole') === 'clientadmin' &&  storage.getItem('ClientGroupName') !== "ALDI" && (
                                <FormControl sx={{ width: 'fit-content', minWidth: '200px' }}>
                                    {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                                    <Autocomplete
                                        className='text-dark'
                                        options={Areamanagerlist || []}
                                        disabled={isGroupScore}
                                        getOptionLabel={(option) => option?.areaName || ''}
                                        value={Areamanagerlist?.find((item) => item.areaId === area) || null}
                                        onChange={(event, newValue) => {
                                            setSelectedArea(newValue?.areaId || '');
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Area" sx={{ color: 'black !important' }} variant="outlined" />
                                        )}

                                        isOptionEqualToValue={(option, value) => option.areaId === value.areaId}
                                    />
                                </FormControl>
                            )}
                            <DatePicker value={startMonth} className='w-50'
                                label="Start: "
                                views={['month', 'year']}
                                format="MMM-YY"
                                maxDate={endMonth}
                                onChange={(e) => { setStartMonth(e); }}
                                sx={{
                                    '& .MuiInputLabel-root': {
                                        fontSize: '14px !important',
                                    }
                                }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                            <DatePicker value={endMonth} className='w-50'
                                label="End: "
                                views={['month', 'year']}
                                format="MMM-YY"
                                sx={{
                                    '& .MuiInputLabel-root': {
                                        fontSize: '14px !important'
                                    }
                                }}
                                minDate={startMonth}
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </Box>
                    </LocalizationProvider>
                    {/* </Box> */}
                </Box>

            </Box>

            {/* ----------------------------------------------------------------------------------------------- */}
            <Box className='d-flex flex-wrap align-items-stretch justify-content-between'>
                <Box width={{ xs: '100%', md: '39%' }} className='border  border-20 py-3 d-flex flex-column align-items-center justify-content-center gap-3'>
                    <Box className='circular-progress'>
                        <CircularProgressbar strokeWidth={8} value={!isNaN(currentmonth / currentlength) ? parseFloat((currentmonth / currentlength).toFixed(2)) : 0} />
                        <Box className='previous'>
                            <CircularProgressbar strokeWidth={10} value={!isNaN(previousmonth / previouslength) ? parseFloat((previousmonth / previouslength).toFixed(2)) : 0} />
                        </Box>
                        <Box className='previous d-flex align-items-center flex-column justify-content-center'>
                            {(!isNaN(previousmonth / previouslength)) && (!isNaN(currentmonth / currentlength)) && (
                                (changemonth / changelength) < 0
                                    ? <TrendingDownOutlined sx={{ color: 'red' }} />
                                    : <TrendingUpOutlined sx={{ color: 'green' }} />
                            )}
                            <Typography className='text-center'>Change</Typography>
                            <Typography className='text-center' fontWeight={900} fontSize='20px' sx={{ color: `${(changemonth / changelength) < 0 ? 'red' : 'green'}` }}>{(changemonth / changelength) && (!isNaN(previousmonth / previouslength)) && (!isNaN(currentmonth / currentlength)) ? (changemonth / changelength).toFixed(2) + '%' : 'N/A'}</Typography>
                        </Box>
                    </Box>
                    <Box className='d-flex gap-3 align-items-center'>
                        <Box className='d-flex align-items-center gap-2'><Box className='current-month'></Box><Typography variant='caption'>{TotalMonth} Months Average</Typography></Box>
                        <Box className='d-flex align-items-center gap-2'><Box className='previous-month'></Box><Typography variant='caption'>Previous {TotalMonth} Months Average</Typography></Box>
                    </Box>
                </Box>
                <Box className='d-flex flex-wrap align-items-stretch pt-4 justify-content-between' gap={{ xs: 1, md: 0 }} width={{ xs: '100%', md: '60%' }}>
                    <Box width={{ xs: '48%', md: '32%' }} position='relative' gap={{ xs: 2, md: 0 }} justifyContent={{ xs: 'start', md: 'space-between' }} height={{ xs: 'auto', md: '100%' }} className='border border-20 p-3 d-flex flex-column align-items-start'>
                        <Typography>{TotalMonth} Months Average</Typography>
                        <Typography className='fw-bold text-secondary' variant='h5'>{(currentmonth / currentlength) ? (currentmonth / currentlength).toFixed(2) + '%' : 'N/A'}</Typography>
                        <Box component='img' width='30%' maxWidth='50px' className='down-img' src={currentlength !== 0 && (currentmonth / currentlength) < (previousmonth / previouslength) ? DownArrow : UpArrow}></Box>
                    </Box>
                    <Box width={{ xs: '48%', md: '32%' }} position='relative' gap={{ xs: 2, md: 0 }} justifyContent={{ xs: 'start', md: 'space-between' }} height={{ xs: 'auto', md: '100%' }} className='border border-20 p-3 d-flex flex-column align-items-start'>
                        <Typography>Previous {TotalMonth} Months Average</Typography>
                        <Typography className='fw-bold text-third' variant='h5'>{(previousmonth / previouslength) ? (previousmonth / previouslength).toFixed(2) + '%' : 'N/A'}</Typography>
                        <Box component='img' width='25%' maxWidth='50px' className='down-img' src={previouslength !== 0 && (currentmonth / currentlength) > (previousmonth / previouslength) ? DownArrow : UpArrow}></Box>
                    </Box>
                    <Box width={{ xs: '48%', md: '32%' }} position='relative' gap={{ xs: 2, md: 0 }} justifyContent={{ xs: 'start', md: 'space-between' }} height={{ xs: 'auto', md: '100%' }} className='border border-20 p-3 d-flex flex-column align-items-start'>
                        <Typography>Change</Typography>
                        <Typography className='fw-bold text-main' variant='h5'>
                            {
                                !isNaN((currentmonth / currentlength) - (previousmonth / previouslength))
                                    ? (((currentmonth / currentlength) - (previousmonth / previouslength)).toFixed(2) + '%')
                                    : "N/A"
                            }
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* --------------------------------------------------------------------------------------------------- */}
            <Box>
                <Typography variant='h5' className='my-1 mt-4'>Venue Comparison</Typography>
                <Box className='d-flex flex-wrap align-items-center justify-content-start' gap={{ xs: 2, xxl: 3 }}>
                    {groupumonthreport.length > 0 && groupumonthreport?.map((item: any, index: number) => (
                        <Box className='mt-2'>
                            <Box sx={{ cursor: 'pointer' }} onClick={() => { handleVenueDashboard(item?.venueId, item?.venueName) }}> <Typography variant='h6'>{item.venueName}</Typography></Box>
                            <Box className='d-flex align-items-stertch justify-content-start gap-5' width='fit-content' position='relative'>
                                <Box sx={{ background: `url(${Left})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }} padding={{ xs: 3, xxl: 5 }} className="left  pr-5 pb-5 h-100 ">
                                    <Typography mr={{ xs: 3, md: 5 }}>Average {TotalMonth}</Typography>
                                    <Typography mr={{ xs: 3, md: 5 }}>Months</Typography>
                                    <Box className='mt-3 c-m' mr={{ xs: 3, md: 5 }}>
                                        <CircularProgressbar
                                            text={item.currentAverage !== null ? parseFloat(item.currentAverage).toFixed(2) + '%' : "0%"}
                                            strokeWidth={20}
                                            value={item.currentAverage !== null ? parseFloat(item.currentAverage) : 0}
                                        />

                                    </Box>
                                </Box>
                                <Box border='1px solid #0000005A' borderRadius='50%' className='inner-circle  d-flex align-items-center flex-column justify-content-center'>
                                    {item.change !== null && item.previousAverage !== null && item.previousAverage !== null && (item.change < 0 ? <TrendingDownOutlined sx={{ color: 'red' }} /> : <TrendingUpOutlined sx={{ color: 'green' }} />)}
                                    <Typography className='text-center'>Change</Typography>
                                    <Typography className='text-center' fontWeight={900} fontSize='16px' sx={{ color: `${item.change < 0 ? 'red' : 'green'}` }}>{item.change !== null && item.previousAverage !== null && item.previousAverage !== null ? `${parseFloat(item.change).toFixed(2)}%` : "N/A"}</Typography>
                                </Box>
                                <Box sx={{ background: `url(${Right})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }} padding={{ xs: 3, xxl: 5 }} className="left d-flex flex-column align-items-end justify-content-end  pl-5 pb-5">
                                    <Typography ml={{ xs: 3, md: 5 }} className='text-end'>Previous {TotalMonth}</Typography>
                                    <Typography ml={{ xs: 3, md: 5 }} className='text-end'>Months</Typography>
                                    <Box ml={{ xs: 3, md: 5 }} className='mt-3 p-m'>
                                        <CircularProgressbar
                                            text={item.previousAverage !== null ? parseFloat(item.previousAverage).toFixed(2) + '%' : "N/A"}
                                            strokeWidth={20}
                                            value={item.previousAverage !== null ? parseFloat(item.previousAverage) : 0}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default CustomeMonthlyReport
